import Model from "./Model";

class ActivityLog extends Model {
  name: String;
  data: any;
  constructor(options) {
    super();
    this.bind(options);
  }
  getTitle(): String {
    switch (this.name) {
      case 'order_payment_initiated':
        return (this.data.type ? this.data.type : '') + ' ' + (this.data.status ? this.data.status : '') + ' - SGD ' + (this.data.total_amount ? this.data.total_amount : '');
      case 'order_payment_paid':
        return (this.data.type ? this.data.type : '') + ' ' + (this.data.status ? this.data.status : '') + ' - SGD ' + (this.data.paid_amount ? this.data.paid_amount : '');
      case 'order_delivery_initiated':
      case 'order_delivery_in_transit':
      case 'order_delivery_arrived':
        return (this.data.status_display_name ? this.data.status_display_name : '');
      case 'order_return_missed':
        return 'RETURN HAS BEEN MISSED';
      case 'order_return_cancelled':
        return 'RETURN HAS BEEN CANCELLED';
      case 'order_delivery_missed':
        return 'DELIVERY HAS BEEN MISSED';
      case 'order_delivery_cancelled':
        return 'DELIVERY HAS BEEN CANCELLED';
      case 'order_payment_waiting':
        return 'WAITING FOR CUSTOMER PAYMENT';
      case 'order_payment_cancelled':
        return 'ORDER PAYMENT HAS BEEN CANCELLED';
    }
    return '';
  }
  getContent(): String {
    switch (this.name) {
      case 'order_payment_initiated':
      case 'order_payment_paid':
      case 'order_delivery_initiated':
      case 'order_delivery_in_transit':
      case 'order_delivery_arrived':
        return this.data.products ? this.data.products.map(s => s.sku + ' - ' + s.name).join(', ') : '';
    }
    return '';
  }
}

export default ActivityLog;
